import useAppSelector from "./base/useAppSelector";

const useCachedAdminConsoleData = () => {
  return useAppSelector((state) => {
    return state.AppData.aConsoleData;
  });
};

export default useCachedAdminConsoleData;
